import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useAuthStore = create()(
  devtools(
    persist(
      (set) => ({
        user: null,
        token: null,
        refreshToken: null,
        setUser: (data) => set(() => ({ user: data })),
        logout: () => set(() => ({ user: null, token: null, refreshToken: null })),
        setToken: (token) => set(() => ({ token: token })),
        setRefreshToken: (token) => set(() => ({ refreshToken: token })),
      }),
      {
        name: "auth",
        partialize: (state) => ({
          token: state.token,
          refreshToken: state.refreshToken,
        }),
      }
    )
  )
);
